'use client'
import { PrismicRichText } from "@prismicio/react";
import { useState } from "react";

/**
 * @typedef {import("@prismicio/client").Content.FaqSlice} FaqSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<FaqSlice>} FaqProps
 * @param {FaqProps}
 */

const FaqCard = ({ question }) => {
  const [isOpen, setIsOpen] = useState(false);
  function toggle() {
    setIsOpen(!isOpen);
  }
  return <div
    className="bg-white border-2 border-dark-grey rounded-30px px-30px py-4 md:p-30px mb-4 md:mb-30px overflow-hidden faq-wrapper-parent">
    <div className="flex md:items-center justify-between cursor-pointer toggle-btn faq-wrapper" onClick={toggle}>
      <PrismicRichText field={question.question} />
      <div className="mt-2 md:mt-0 w-fit ml-2.5" >
        <div className={`spin_arrow h-2 w-4 ${isOpen ? 'toggle-active' : ''}`}>
          <img src="/svg/arrow-faq.svg"  className="w-4 h-[9px]" alt="flèche"/>
        </div>
      </div>
    </div>
    <div className={`mt-2.5 ${isOpen ? '' : 'hidden'} block`}>
      <PrismicRichText field={question.answer} />
    </div>
  </div>
}
const Faq = ({ slice, index }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`bg-green ${index !== 0 ? 'border-t-2 border-dark-grey' : ''}`}>
      <div className="pt-14 md:pt-[120px] pb-12 md:pb-[100px] px-4 md:px-7 lg:px-10 text-dark-grey">
        <div className="m-auto">
          <div className="text-center mb-[40px]">
            <div className="h2-like mb-30px">
              <PrismicRichText field={slice.primary.title} />
            </div>
            <div>
              <PrismicRichText field={slice.primary.text} />
            </div>
          </div>
          <div className="max-w-[800px] m-auto">
            {
              slice.primary.questions.map((question, i) => <FaqCard key={i} question={question} />)
            }
          </div>
        </div>
      </div>
    </section>
  );
};

export default Faq;
